<h2 mat-dialog-title>{{category_id? 'Update Category' : 'Add Category'}}</h2>
<form [formGroup]="CategoryForm" (ngSubmit)="onFormSubmit()">
    <mat-dialog-content class="content">
        <div class="column">

            <mat-form-field appearance="outline">
                <mat-label>Category</mat-label>
                <input [ngModel]="category" formControlName="category" matInput placeholder="Enter Category Name">
            </mat-form-field>
        </div>

    </mat-dialog-content>
    <mat-dialog-actions class="action" align="end">
        <button mat-raised-button type="button" color="warn" [mat-dialog-close]="false">Cancel</button>
        <button mat-raised-button type="submit" color="primary">{{category_id? 'Update' : 'Add'}}</button>
    </mat-dialog-actions>
</form>